namespace $ {

	export class $shm_echarts_settings_store extends $mol_object2 {

		static easing_allowed = new Set([ 'cubicInOut', 'cubicOut', 'cubicIn', 'linear' ])

		static duration_normalize( value: unknown ) {
			const duration = Number( value )
			return Number.isFinite( duration ) ? Math.max( 0, Math.round( duration ) ) : 300
		}

		static duration( next?: number ) {
			const key = 'shm_echarts_animation_duration_ms'
			if( next !== undefined ) {
				const duration = this.duration_normalize( next )
				return $mol_state_local.value< number >( key, duration ) ?? duration
			}

			const stored = $mol_state_local.value< unknown >( key )
				?? $mol_state_local.value< unknown >( 'hitalama_echarts_animation_duration_ms' )
			if( stored !== null && stored !== undefined ) return this.duration_normalize( stored )

			const legacy = $mol_state_local.value< string >( 'hitalama_echarts_animation_speed' ) ?? 'normal'
			return ({
				off: 0,
				fast: 150,
				normal: 300,
				slow: 600,
			} as Record< string, number >)[ legacy ] ?? 300
		}

		static duration_setting( key: string, legacy_key: string, next?: number ) {
			if( next !== undefined ) {
				const duration = this.duration_normalize( next )
				return $mol_state_local.value< number >( key, duration ) ?? duration
			}

			const stored = $mol_state_local.value< unknown >( key )
				?? $mol_state_local.value< unknown >( legacy_key )
			return stored === null || stored === undefined
				? this.duration()
				: this.duration_normalize( stored )
		}

		static duration_initial( next?: number ) {
			return this.duration_setting(
				'shm_echarts_animation_duration_initial_ms',
				'hitalama_echarts_animation_duration_initial_ms',
				next,
			)
		}

		static duration_update( next?: number ) {
			return this.duration_setting(
				'shm_echarts_animation_duration_update_ms',
				'hitalama_echarts_animation_duration_update_ms',
				next,
			)
		}

		static easing_normalize( value: unknown ) {
			const easing = String( value || '' )
			return this.easing_allowed.has( easing ) ? easing : 'cubicInOut'
		}

		static easing( next?: string ) {
			const key = 'shm_echarts_animation_easing'
			if( next !== undefined ) {
				const easing = this.easing_normalize( next )
				return $mol_state_local.value< string >( key, easing ) ?? easing
			}

			return this.easing_normalize(
				$mol_state_local.value< unknown >( key )
					?? $mol_state_local.value< unknown >( 'hitalama_echarts_animation_easing' ),
			)
		}

		@ $mol_mem
		static duration_initial_runtime( next?: number ) {
			return next ?? this.duration_initial()
		}

		@ $mol_mem
		static duration_update_runtime( next?: number ) {
			return next ?? this.duration_update()
		}

		@ $mol_mem
		static easing_runtime( next?: string ) {
			return next ?? this.easing()
		}

	}

}

namespace $.$$ {

	export class $shm_echarts_settings extends $.$shm_echarts_settings {

		animation_duration_initial( next?: number ) {
			if( next === undefined ) return this.$.$shm_echarts_settings_store.duration_initial_runtime()
			const value = this.$.$shm_echarts_settings_store.duration_initial( next )
			return this.$.$shm_echarts_settings_store.duration_initial_runtime( value )
		}

		animation_duration_update( next?: number ) {
			if( next === undefined ) return this.$.$shm_echarts_settings_store.duration_update_runtime()
			const value = this.$.$shm_echarts_settings_store.duration_update( next )
			return this.$.$shm_echarts_settings_store.duration_update_runtime( value )
		}

		animation_easing( next?: string ) {
			if( next === undefined ) return this.$.$shm_echarts_settings_store.easing_runtime()
			const value = this.$.$shm_echarts_settings_store.easing( next )
			return this.$.$shm_echarts_settings_store.easing_runtime( value )
		}

	}

}
